import { render, staticRenderFns } from "./MainNavigation.vue?vue&type=template&id=79335a6c&scoped=true&"
import script from "./MainNavigation.vue?vue&type=script&lang=js&"
export * from "./MainNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MainNavigation.vue?vue&type=style&index=0&id=79335a6c&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../.yarn/$$virtual/vue-loader-virtual-a9dd69dad6/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79335a6c",
  null
  
)

export default component.exports